import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

const tableHeader: TableHeaderItem[] = [
  { prop: 'index', label: '序号', width: 60, fixed: "left" },
  { prop: 'strCode', label: '条码', width: 200 },
  { prop: 'ThreeCode', label: '三段码', width: 200 },
  { prop: 'LatticeNo', label: '格口号', width: 80 },
  { prop: 'LineName', label: '线路名称', width: 200 },
  { prop: 'NextOrgCode', label: "下一网点", width: 120 },
  { prop: 'ScanTime', label: '操作时间', width: null },
  { prop: "state", label: "上传状态", width: null },
  { prop: 'Info', label: '提示/警告信息', width: null, fixed: "right" },
];
export default { tableHeader }
